import { useState, useCallback, useEffect, useRef } from 'react';

const GameModel = ({
  showModal,
  showLevelUpModal,
  showModalGameComplete,
  resetButtonThrow,
  showModalSoal,
}) => {
  const initialState = {
    ball: {
      x: 75,
      y: 530,
      dx: 0,
      dy: 0,
      radius: 70,
      isHeld: false,
    },
    paddle: {
      height: 30,
      width: 250,
      x: 0,
      isVisible: true,
    },
    rightPressed: false,
    leftPressed: false,
    paddleHit: 0,
    isGameOver: false,
    score: 0,
    seeds: 0,
    seedsPerLevel: 0,
    seedsToCollect: 1,
    collectedSeed: 0,
    canCollectSeed: true,
    throwSeed: false,
    levels: 1,
  };

  const [gameState, setGameState] = useState(initialState);
  const [isRunning, setIsRunning] = useState(false);
  const [isBallHeld, setIsBallHeld] = useState(false);
  const [resetQTE, setResetQTE] = useState(false);
  const [resetSeed, setResetSeed] = useState(false);
  const intervalRef = useRef(null);

  const showStatus = useCallback(() => {
    setGameState((prevState) => {
      console.log(`Progress:
                \nScore: ${prevState.score}\nseeds: ${prevState.seeds}\ncollectedSeed: ${prevState.collectedSeed}\nthrowSeed: ${prevState.throwSeed}
                \nProgress/Level
                \nseedsPerLevel: ${prevState.seedsPerLevel}\nseedsToCollect: ${prevState.seedsToCollect}`);
      return prevState;
    });
  }, [setGameState]);

  const startGame = useCallback(() => {
    setGameState(initialState);
    setIsRunning(false);
    setResetQTE(true);
    resetButtonThrow();
    setResetSeed(true);
    setTimeout(() => setResetSeed(false), 0);
  }, [initialState, resetButtonThrow]);

  const continueCurrentGame = useCallback(() => {
    setGameState((prevState) => ({
      ...initialState,
      score: prevState.score,
      collectedSeed: prevState.collectedSeed,
      levels: prevState.levels,
      canCollectSeed: true,
      seeds: prevState.seeds,
      seedsPerLevel: prevState.seedsPerLevel,
      seedsToCollect: prevState.seedsToCollect,
      paddleHit: 0,
    }));
    setIsRunning(false);
    setResetQTE(true);
  }, [initialState]);

  const setBallSpeed = useCallback((dy) => {
    setGameState((prevState) => ({
      ...prevState,
      ball: { ...prevState.ball, dy },
    }));
  }, []);

  const setBallHeld = useCallback((isHeld) => {
    setGameState((prevState) => ({
      ...prevState,
      ball: { ...prevState.ball, isHeld, dy: isHeld ? 0 : prevState.ball.dy },
    }));
  }, []);

  useEffect(() => {
    if (resetQTE) {
      setResetQTE(false);
    }
  }, [resetQTE]);

  const handleEvent = useCallback(
    (clientX, clientY) => {
      const canvas = document.getElementById("myCanvas");
      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;
      const mouseX = (clientX - rect.left) * scaleX;
      const mouseY = (clientY - rect.top) * scaleY;

      const dx = mouseX - gameState.ball.x;
      const dy = mouseY - gameState.ball.y;

      if (dx * dx + dy * dy <= gameState.ball.radius * gameState.ball.radius) {
        if (gameState.isGameOver) {
          return;
        }
        switch (gameState.paddleHit) {
          case 2:
            if (gameState.throwSeed) {
              console.log("biji dilempar");
              setGameState((prevState) => ({
                ...prevState,
                score: prevState.score + 10,
              }));
            } else if (gameState.collectedSeed === gameState.seedsToCollect) {
              setGameState((prevState) => {
                if (prevState.seedsToCollect === 4) {
                  return {
                    ...prevState,
                    collectedSeed: 0,
                    seedsToCollect: prevState.seedsPerLevel - 2,
                  };
                } else if (prevState.seedsToCollect === 5) {
                  return {
                    ...prevState,
                    collectedSeed: 0,
                    seedsToCollect: prevState.seedsPerLevel - 4,
                  };
                } else if (prevState.seedsPerLevel === 6) {
                  if (prevState.levels === 6) {
                    showModalGameComplete();
                    return {
                      ...prevState,
                      score: prevState.score + 10 * prevState.levels,
                    };
                  } else {
                    showLevelUpModal("Level Up");
                    resetButtonThrow();
                    return {
                      ...prevState,
                      levels: prevState.levels + 1,
                      collectedSeed: 0,
                      score: prevState.score + 10 * prevState.levels,
                      seedsPerLevel: prevState.seedsPerLevel - 6,
                    };
                  }
                } else {
                  return {
                    ...prevState,
                    collectedSeed: 0,
                    score: prevState.score + 10 * prevState.levels,
                  };
                }
              });
            } else {
              showModal(
                "Game Over, Oops kamu menangkap bola sebelum melempar/mengumpulkan biji"
              );
            }
            showModalSoal();
            showStatus();
            continueCurrentGame();
            break;
          case 1:
            showModal("Game Over, Oops kamu terlalu cepat menangkap bola");
            break;
          default:
            setIsBallHeld(true);
            setBallHeld(true);
            break;
        }
      }
    },
    [
      gameState,
      startGame,
      setBallHeld,
      continueCurrentGame,
      showModal,
      showLevelUpModal,
      showModalGameComplete,
      setResetSeed,
      showStatus,
    ]
  );

  const handleMouseDown = useCallback(
    (e) => {
      handleEvent(e.clientX, e.clientY);
    },
    [handleEvent]
  );

  const handleTouchStart = useCallback(
    (e) => {
      handleEvent(e.touches[0].clientX, e.touches[0].clientY);
    },
    [handleEvent]
  );

  const updateGame = useCallback(() => {
    setGameState((prevState) => {
      let { ball, paddle, paddleHit, canCollectSeed } = prevState;
      let { x, y, dy, radius, isHeld } = ball;

      if (isHeld) {
        return prevState;
      }

      if (y + dy < radius) {
        dy = -dy;
      } else if (y + dy > 600 - radius) {
        if (x > paddle.x && x < paddle.x + paddle.width && paddle.isVisible) {
          dy = -dy;
          paddleHit += 1;
          if (paddleHit === 2) {
            if (prevState.throwSeed) {
              canCollectSeed = true;
            }
          } else if (paddleHit === 3) {
            showModal("Game over, Yahhh bolamu jatuh.!!!");
            continueCurrentGame();
          }
        }
      }

      y += dy;

      return {
        ...prevState,
        ball: { ...ball, y, dy },
        paddle: { ...paddle },
        paddleHit,
        canCollectSeed,
      };
    });
  });

  const handleMouseUp = useCallback(() => {
    if (isBallHeld) {
      setIsBallHeld(false);
      setBallHeld(false);
      if (gameState.paddleHit === 0) {
        setIsRunning(true);
      }
    }
  }, [isBallHeld, gameState.paddleHit, setBallHeld]);

  const handleTouchEnd = useCallback(() => {
    if (isBallHeld) {
      setIsBallHeld(false);
      setBallHeld(false);
      if (gameState.paddleHit === 0) {
        setIsRunning(true);
      }
    }
  }, [isBallHeld, gameState.paddleHit, setBallHeld]);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(updateGame, 10);
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [isRunning, updateGame]);

  useEffect(() => {
    const events = [
      { type: "mousedown", handler: handleMouseDown },
      { type: "mouseup", handler: handleMouseUp },
      { type: "touchstart", handler: handleTouchStart },
      { type: "touchend", handler: handleTouchEnd },
    ];

    events.forEach(({ type, handler }) => {
      window.addEventListener(type, handler);
    });

    return () => {
      events.forEach(({ type, handler }) => {
        window.removeEventListener(type, handler);
      });
    };
  }, [handleMouseDown, handleMouseUp, handleTouchStart, handleTouchEnd]);

  const throwSeed = useCallback(() => {
    setGameState((prevState) => {
      if (!prevState.throwSeed && prevState.paddleHit === 2) {
        return {
          ...prevState,
          throwSeed: (prevState.throwSeed = true),
        };
      } else {
        showModal("kamu melempar sebelum bola mematul");
      }
      return prevState;
    });
  }, []);

  const collectSeed = useCallback(() => {
    setGameState((prevState) => {
      switch (prevState.paddleHit) {
        case 0:
          showModal("Game Over, kamu mengambil biji sebelum bola bergerak");
          break;
        case 1:
          showModal("Game Over, kamu mengambil biji sebelum bola memantul 1x");
          break;
        case 2:
          if (prevState.canCollectSeed) {
            if (prevState.collectedSeed >= prevState.seedsToCollect) {
              showModal("Game Over, kamu mengambil biji terlalu banyak");
            }
            if (prevState.throwSeed) {
              showModal("Game Over, kamu mengambil biji kecepetan");
            } else {
              return {
                ...prevState,
                seeds: prevState.seeds + 1,
                collectedSeed: prevState.collectedSeed + 1,
                seedsPerLevel: prevState.seedsPerLevel + 1,
              };
            }
          }
          break;
        default:
          break;
      }
      return prevState;
    });
  }, [showModal]);

  const levelLogic = useCallback(() => {
    switch (gameState.levels) {
      case 1:
        console.log("Level 1");
        showStatus();
        setGameState((prevState) => ({
          ...prevState,
          seedsToCollect: 1,
        }));
        break;
      case 2:
        console.log("Level 2");
        showStatus();
        setGameState((prevState) => ({
          ...prevState,
          seedsToCollect: 2,
        }));
        break;
      case 3:
        console.log("Level 3");
        showStatus();
        setGameState((prevState) => ({
          ...prevState,
          seedsToCollect: 3,
        }));
        break;
      case 4:
        console.log("Level 4");
        showStatus();
        setGameState((prevState) => ({
          ...prevState,
          seedsToCollect: 4,
        }));
        break;
      case 5:
        console.log("Level 5");
        showStatus();
        setGameState((prevState) => ({
          ...prevState,
          seedsToCollect: 5,
        }));
        break;
      case 6:
        console.log("Level 6");
        showStatus();
        setGameState((prevState) => ({
          ...prevState,
          seedsToCollect: 6,
        }));
        break;
      default:
        console.log("No specific logic for this level");
        break;
    }
  }, [gameState.levels]);

  useEffect(() => {
    levelLogic();
  }, [gameState.levels, levelLogic]);

  return {
    gameState,
    startGame,
    continueCurrentGame,
    setBallSpeed,
    setBallHeld,
    isBallHeld,
    resetQTE,
    collectSeed,
    resetSeed,
    throwSeed,
  };
};

export default GameModel;
